import { Component } from '@angular/core';
import { FormControl, FormBuilder, AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import * as moment from 'moment';
import { MyQuotation } from 'src/app/core/models/my-quotation .model';
import { ErrorHandlerService } from 'src/app/core/services/error-handler.service';
import { LoaderService } from 'src/app/core/services/loader.service';
import { RestService } from 'src/app/core/services/rest.service';
export function dateRangeValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const fromDate = control.get('fromDate')?.value;
    const toDate = control.get('toDate')?.value;

    if ((fromDate && !toDate) || (!fromDate && toDate)) {
      return { dateRangeRequired: true };
    }

    return null;
  };
}
@Component({
  selector: 'app-my-quotation',
  templateUrl: './my-quotation.component.html',
  styleUrls: ['./my-quotation.component.scss']
})
export class MyQuotationComponent {
  currentPage: number = 1;
  row_count: number = 1;
  page_count: number = 10;
  totalCount: number = 0;
  resultPerpage = new FormControl(10);
  myQuotationList: MyQuotation[] = [];
  currentDate:any=moment();
  lastSeventDate:any=moment().subtract(7, 'days');
  myQuotationFilters = this.fb.group({
    quotationNumber: [''],
    fromDate: [this.lastSeventDate],
    toDate: [this.currentDate]
  }, { validators: dateRangeValidator() });
  isLoadingForMyQuotationList = true;

  constructor(
    private fb: FormBuilder,
    private restService: RestService,
    private loader: LoaderService,
    private router: Router,
    private errorHandler: ErrorHandlerService,
  ) {

  }

  ngOnInit() {
    this.resultPerpage.valueChanges.subscribe(value => {
      this.row_count = 1;
      this.page_count = parseFloat(this.resultPerpage?.value?.toString() ?? '');
      this.currentPage = 1;
      this.GetAllMyQuotation();
    });
    this.myQuotationFilters.get('fromDate')?.valueChanges.subscribe(fromDate => {
      const toDate = this.myQuotationFilters.get('toDate')?.value;
    
      if (fromDate && toDate && moment(fromDate).isAfter(moment(toDate))) {
        this.myQuotationFilters.patchValue({ toDate: null }, { emitEvent: false });
      }
    });
    
    this.myQuotationFilters.get('toDate')?.valueChanges.subscribe(toDate => {
      const fromDate = this.myQuotationFilters.get('fromDate')?.value;

      if (fromDate && toDate && moment(toDate).isBefore(moment(fromDate))) {
        this.myQuotationFilters.patchValue({ fromDate: null }, { emitEvent: false });
      }
    });
    this.GetAllMyQuotation();
  }

  goBack() {
    this.router.navigate(['quotation/get-quote']);
  }

  GetAllMyQuotation() {
    let params = {
      PageNo: this.row_count,
      PageSize: this.page_count,
      QuotationNumber: this.myQuotationFilters.get('quotationNumber')?.value?.trim() || null,
      FromDate: this.myQuotationFilters.get('fromDate')?.value ? moment(this.myQuotationFilters.get('fromDate')?.value).format('YYYY-MM-DD') : null,
      ToDate: this.myQuotationFilters.get('toDate')?.value ? moment(this.myQuotationFilters.get('toDate')?.value).format('YYYY-MM-DD') : null
    }
    this.loader.show();
    this.restService.postData(params, 'api/Quotation/MyQuotation').subscribe(
      {
        next: (data: any) => {
          try {
            if (data.rcode == 200) {
              this.myQuotationList = data.rObj.MyQuotation || [];
              this.isLoadingForMyQuotationList = false;
              this.totalCount = data.rObj.TotalRecords;
            } else {
              this.errorHandler.handleRcodeError(data);
            }
          } catch (error) {
            this.errorHandler.internalError();
          } finally {
            this.loader.hide();
          }
        },
        error: (error: any) => {
          this.isLoadingForMyQuotationList = false;
          this.loader.hide();
          this.errorHandler.handleStatusError(error);
        }
      })
  }

  QuotationDetailes(quotationID: string) {
    this.router.navigate(['quotation/quotation-premium', quotationID]);
  }

  onPageChange(page: number) {
    this.row_count = page;
    this.GetAllMyQuotation();
    window.scrollTo(0, 0);
  }

  Filter() {
    if(this.myQuotationFilters.invalid){
      return;
    }
    this.row_count = 1;
    this.currentPage = 1;
    this.GetAllMyQuotation();
  }

  ClearFilter() {
    this.myQuotationFilters.reset();
    this.page_count = 10;
    this.resultPerpage.patchValue(10);
  }
}
